module.exports = __webpack_public_path__ + "img/bg_contact.ec469c6a.jpg";